import { createFileRoute } from '@tanstack/react-router';
import AddDomain from '../../../../../packages/domains-crate/components/AddDomain/AddDomain';

export const Route = createFileRoute('/_secured/administration/account/domains/m/add-domain')({
  component: AddDomain,
});
